export function withRevokedToken(tokens, id, revokedAt = new Date().toISOString()) {
  return tokens.map((item) => (item.id === id ? { ...item, revokedAt } : item));
}
